module.exports = __webpack_public_path__ + "static/charities-3fdbe94a1e72395ecbb49cc6079494a6.jpg";